/* eslint-disable @typescript-eslint/no-explicit-any */
export const filterObject = <T extends Record<string, any>>(
  obj: T,
): {
  [K in keyof T as Exclude<T[K], null | undefined> extends never
    ? never
    : K]: Exclude<T[K], null | undefined>
} => {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => Boolean(value)),
  ) as any
}
